module.exports = __webpack_public_path__ + "img/sparckle-star-2-mob.cb7b698.svg";